import React, {useEffect, useState} from 'react';
import '../../../../../assets/css/stylesheet.scss';
import '../assets/css/claimProfile.scss';
import PersonAddOutline from '../assets/img/person-add-outline-icon.svg';
import ConnectIcon from '../assets/img/connect-icon.svg';
import LoupeIcon from '../assets/img/loupe-icon.svg';
import SuccessStory1 from '../assets/img/success-stories-img01.png';
import SuccessStory2 from '../assets/img/success-stories-img02.png';
import SuccessStory3 from '../assets/img/success-stories-img03.png';
import NcaaImg from '../assets/img/ncaa.png';
import NaiaImg from '../assets/img/naia.png';
import NjcaaImg from '../assets/img/njcaa.png';
import Cccaa from '../assets/img/cccaa.png';
import ClaimBanner from '../assets/img/claimbanner.svg';
import Nwac from '../assets/img/Nwac.png';
import Norton from '../assets/img/norton.png';
import CertifiedComplaint from '../assets/img/certifiedCompliant.png';
import {Link, useHistory} from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/owl.carousel.min.js';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import {IsValidEmail} from '../../../../../utils/validationUtils';
import { fetchMethod } from '../../../../../services/httpService';

const Athlete_Sports = [
  {id: 1, value: "Athlete's sport"},
  {id: 2, value: "Athlete's sport"},
  {id: 3, value: "Athlete's sport"},
];

//Owl.Carousel 
const options = {
  items: 7,
  loop: true,
  nav: true,
  dots: false,
  margin: 20,
 
  responsive: {
    0: {
      items: 2,
    },
    480: {
      items: 3,
    },
    640: {
      items: 4,
    },
    1000: {
      items: 7,
      margin: 20,
    },
  },
};
const ClaimProfile = () => {
  let history = useHistory();

  const initialValues = {
    email: '',
    athleteSport: '',
  };

  const [fields, setFields] = useState({...initialValues});
  const [errors, setErrors] = useState({});

  const handleClaimProfile = (e) => {
    e.preventDefault();
    //  history.push('/claimProfileStep1');
  };

  const handleCreateMyProfile = (e) => {
    e.preventDefault();
    const {formIsValid, updatedValue} = handleValidation();
    if (formIsValid) {
      console.log('e', fields);
    }
  };

  const handleChange = (field, e) => {
    //const { formIsValid, updatedValue } = handleValidation(field, e);
    setErrors({
      errorsT:"",
    });
    let fieldsT = fields;
    fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
    setFields({
      ...fieldsT,
    });
  };
  // const handleChange = (field, e) => {
  //   const {formIsValid, updatedValue} = handleValidation(field, e);
  //   let fieldsT = fields;
  //   fieldsT[field] = updatedValue;
  //   setFields({
  //     ...fieldsT,
  //   });
  // };
  useEffect(async ()=>{
    const obj ={
      url : '/api/Visitors/addtotalVisitor',
      method:"post",
      body:null,
      headers: false
  }
  const res = await fetchMethod(obj?.url, obj?.data, obj?.method, obj?.headers);
  },[])

  const handleValidation = (fieldname, e) => {
    let errorsT = errors;
    let formIsValid = true;
    let fieldValue = e ? (e.target ? e.target.value : e) : e;
    let updatedValue = fieldValue;
    //email validations
    if (fieldname === undefined || fieldname === 'email') {
      if (fieldname === undefined) {
        fieldValue = fields['email'] ? fields['email'] : '';
        updatedValue = fieldValue;
      }
      delete errorsT['email'];
      if (!updatedValue) {
        formIsValid = false;
        errorsT['email'] = 'Email Address is required';
      } else if (!IsValidEmail(updatedValue)) {
        formIsValid = false;
        errorsT['email'] = 'Please enter Email in correct format';
      }
    }

    setErrors({
      ...errorsT,
    });
    return {
      formIsValid,
      updatedValue,
    };
  };
  return (
    <div>
      <section
        className="page-banner"
        style={{backgroundImage: ` url(${ClaimBanner})`}}
      >
        <div className="container">
          <div className="banner-content-box">
            <h1 className="banner-title">Getting Recruited Starts Here.</h1>
            <div className="banner-short-text">
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled
              </p>
            </div>
            <div className="banner-button-box">
              <button
                disabled = {true}
                className="btn"
                onClick={(e) => handleClaimProfile(e)}
              >
                Claim your profile
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-work-sec common-padding">
        <div className="container">
          <h2 className="sec-title">How it's works</h2>
          <ul className="hw-work-listing">
            <li>
              <div className="icon-box">
                <img src={PersonAddOutline} alt="Create free profile" />
              </div>
              <div className="content-box">
                <h3>Create free profile</h3>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat.
                </p>
              </div>
            </li>
            <li>
              <div className="icon-box">
                <img src={ConnectIcon} alt="Connect with college coatch" />
              </div>
              <div className="content-box">
                <h3>Connect with college coatch</h3>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat.
                </p>
              </div>
            </li>
            <li>
              <div className="icon-box">
                <img src={LoupeIcon} alt="Discovered by coaches" />
              </div>
              <div className="content-box">
                <h3>Discovered by coaches</h3>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <section className="dream-college-sec common-padding">
        <div className="container">
          <h3 className="sec-title">Dream college is just single click away</h3>

          <OwlCarousel
            className="dream-college-logos owl-carousel"
            {...options} 
          >
            <div className="item">
              <img src={NcaaImg} alt="" />
            </div>
            <div className="item">
              <img src={NaiaImg} alt="" />
            </div>
            <div className="item">
              <img src={NjcaaImg} alt="" />
            </div>
            <div className="item">
              <img src={Cccaa} alt="" />
            </div>
            <div className="item">
              <img src={Nwac} alt="" />
            </div>
            <div className="item">
              <img src={Norton} alt="" />
            </div>
            <div className="item">
              <img src={CertifiedComplaint} alt="" />
            </div>
          </OwlCarousel>
        </div>
      </section>
      <section className="common-padding create-profile-sec">
        <div className="container">
          <h3 className="sec-title">Create your profile</h3>
          <div className="create-profile-inner">
            <ul className="tabs">
              <li data-tab="tab1" style={{cursor: "pointer"}}>
                <a href={void 0}>I'm an athelete</a>
              </li>
              <li className="current" data-tab="tab2" style={{cursor: "pointer"}}>
                <a href={void 0}>I'm a parent</a>
              </li>
            </ul>
            <div className="tabs-data-wrapper">
              <div id="tab1" className="tab-content current">
                <div className="form-group">
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={fields.email}
                    onChange={(e) => {
                      handleChange('email', e);
                    }}
                  />
                  <div className="error">{errors['email']}</div>
                </div>
                <div className="form-group">
                  <select
                    className="form-control custom-select"
                    id="athleteSport"
                    name="athleteSport"
                    value={fields.athleteSport || ''}
                    onChange={(e) => handleChange('athleteSport', e)}
                  >
                    <option value="">Athlete's sport</option>
                    {Athlete_Sports &&
                      Athlete_Sports.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.value}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div id="tab2" className="tab-content">
                <div className="form-group">
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                  />
                </div>
                <div className="form-group">
                  <select className="form-control custom-select " id="" name="">
                    <option value="">Athlete's</option>
                    <option value="">Athlete's</option>
                    <option value="">Athlete's</option>
                    <option value="">Athlete's</option>
                    <option value="">Athlete's</option>
                  </select>
                </div>
              </div>
              <div className="button-box">
                <button
                  className="btn"
                  onClick={(e) => handleCreateMyProfile(e)}
                >
                  Create My Free Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="common-padding play-sport-sec">
        <div className="container">
          <h3 className="sec-title">Want to Play College Sports</h3>
          <ul className="play-sport-listing">
            <li>
              <a href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="129.039"
                  height="128.042"
                  viewBox="0 0 129.039 128.042"
                >
                  <defs>
                    <style>
                      {` .a {
                                        fill: #00b9ff;
                                    }`}
                    </style>
                  </defs>
                  <g transform="translate(-6.805 19.448) rotate(-16)">
                    <g transform="translate(0 7.784)">
                      <g transform="translate(0)">
                        <path
                          className="a"
                          d="M107.093,92.116l-.188-.188a6.7,6.7,0,0,0-9.2,0l-9.767,9.955a1.255,1.255,0,0,1-1.878,0L72.344,89.11a7.509,7.509,0,0,0-4.884-1.878H46.986a1.588,1.588,0,0,0-1.127.376L28.578,104.137c-2.442,2.63-2.63,6.762-.376,9.2a6.369,6.369,0,0,0,9.392,0L49.8,100.381h4.32l-28.55,31.931H7.917A7.686,7.686,0,0,0,.028,139.45a7.075,7.075,0,0,0,2.066,5.635,8.367,8.367,0,0,0,5.447,2.254h26.3a1.705,1.705,0,0,0,1.315-.563l13.524-14.463,11.27,11.834-3.381,21.789a7.619,7.619,0,0,0,4.132,8.828,6.637,6.637,0,0,0,3.193.751,7.368,7.368,0,0,0,3.381-.751,7.8,7.8,0,0,0,3.945-5.072l5.823-31.368a2.623,2.623,0,0,0-.563-1.691l-15.59-15.59,12.4-12.4,8.64,8.64a6.464,6.464,0,0,0,9.016,0l16.154-16.154A6.464,6.464,0,0,0,107.093,92.116Zm-2.63,6.386L88.31,114.656a2.854,2.854,0,0,1-3.757,0L74.6,104.7a1.816,1.816,0,0,0-2.63,0L56.942,119.727a1.7,1.7,0,0,0-.563,1.315,1.94,1.94,0,0,0,.751,1.5L73.283,138.7,67.648,168.94a5.2,5.2,0,0,1-2.066,2.442,3.788,3.788,0,0,1-3.193,0c-1.691-.751-2.442-2.63-2.066-4.7l3.569-22.916a2.133,2.133,0,0,0-.563-1.5l-13.336-13.9a1.7,1.7,0,0,0-1.315-.563,1.462,1.462,0,0,0-1.315.563L33.087,143.582H7.541a3.822,3.822,0,0,1-2.817-1.127,4.614,4.614,0,0,1-.939-2.817c0-2.066,1.878-3.569,4.132-3.569H26.325c.563,0,.939-.188,1.315-.188l31.932-35.688a2.047,2.047,0,0,0,.376-2.066A1.643,1.643,0,0,0,58.257,97H48.865a2.029,2.029,0,0,0-1.315.563L34.777,111.087a2.312,2.312,0,0,1-1.878.939,3.016,3.016,0,0,1-2.066-.939,2.9,2.9,0,0,1,.188-3.945L47.738,91.177h19.91a3.466,3.466,0,0,1,2.254.939l13.712,12.773a5.224,5.224,0,0,0,7.138-.188l9.767-9.955a2.856,2.856,0,0,1,3.757,0l.188.188A2.612,2.612,0,0,1,104.463,98.5Z"
                          transform="translate(0 -70.327)"
                        />
                        <path
                          className="a"
                          d="M364.506,30.324a11.27,11.27,0,1,0-11.27-11.27A11.3,11.3,0,0,0,364.506,30.324Zm0-18.783a7.513,7.513,0,1,1-7.513,7.513A7.535,7.535,0,0,1,364.506,11.541Z"
                          transform="translate(-278.074 -7.784)"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                <span className="title">Athelete</span>
                <span className="link-get-started">Get Started</span>
              </a>
            </li>
            <li>
              <a href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="98.104"
                  height="98.104"
                  viewBox="0 0 98.104 98.104"
                >
                  <defs>
                    <style>
                      {`.a {
                                        fill: #fff;
                                    }`}
                    </style>
                  </defs>
                  <g transform="translate(4 1)">
                    <g transform="translate(0 -1)">
                      <path
                        className="a"
                        d="M93.2,80.427c-9.759-5.175-17.244-8.077-23.908-9.189l.69-.948a1.272,1.272,0,0,0,.327-1.308l-1.532-6.129q.833-1.178,1.57-2.431c6.093-2.074,9.174-5.579,9.692-10.741a5.391,5.391,0,0,0,4.986-5.225V32.192a5.273,5.273,0,0,0-4.934-5.223C79.73,17.523,75.565-1,49.052-1S18.374,17.524,18.014,26.969a5.27,5.27,0,0,0-4.934,5.223V44.455a5.413,5.413,0,0,0,5.4,5.232h2.453a4.985,4.985,0,0,0,2.522-.7,35.756,35.756,0,0,0,5.877,13.867L27.8,68.981a2.2,2.2,0,0,0,.327,1.308l.69.948C22.15,72.35,14.664,75.252,4.905,80.427A8.7,8.7,0,0,0,0,88.439v7.031A1.545,1.545,0,0,0,1.635,97.1H96.469A1.545,1.545,0,0,0,98.1,95.469V88.439A9.374,9.374,0,0,0,93.2,80.427Zm-44.138-3.74,3.915,8.972h-7.9ZM43.885,88.929H54.213l.957,4.905H42.9ZM66.221,66.038l.654,2.943L65.2,71.275a1.459,1.459,0,0,0-.292.323l-6.8,9.417-2.158,2.963L51.545,74.06a23.726,23.726,0,0,0,14-7.322C65.774,66.509,66,66.276,66.221,66.038Zm6.385-10.171a35.388,35.388,0,0,0,2.057-6.927,5.138,5.138,0,0,0,2.1.715A7.981,7.981,0,0,1,72.605,55.867ZM81.59,32.028V44.292a1.988,1.988,0,0,1-1.962,1.962H77.175a1.988,1.988,0,0,1-1.962-1.962V32.028a1.988,1.988,0,0,1,1.962-1.962h2.453A1.988,1.988,0,0,1,81.59,32.028ZM49.052,2.27c10.078,0,27.04,3.29,27.769,24.716a5.2,5.2,0,0,0-1.935.6,26.16,26.16,0,0,0-51.667-.005,5.134,5.134,0,0,0-1.936-.594C22.013,5.56,38.974,2.27,49.052,2.27ZM22.727,44.292a1.988,1.988,0,0,1-1.962,1.962H18.313a1.988,1.988,0,0,1-1.962-1.962V32.028a1.988,1.988,0,0,1,1.962-1.962h2.453a1.988,1.988,0,0,1,1.962,1.962ZM26.161,31.7a22.891,22.891,0,0,1,45.782,0V43.147a30.261,30.261,0,0,1-3.692,14.541c-3.9,1.132-9.517,1.81-17.564,1.81a1.635,1.635,0,1,0,0,3.27A82.261,82.261,0,0,0,65.54,61.65l-.3.3a27.411,27.411,0,0,1-2.6,3c-3.85,3.587-8.442,5.759-12.867,5.975a1.843,1.843,0,0,0-.722-.144,1.565,1.565,0,0,0-.681.146,18.486,18.486,0,0,1-8.108-2.451,26.564,26.564,0,0,1-7.4-6.524l-.491-.491-.1-.032a30.125,30.125,0,0,1-6.118-18.281V31.7Zm20.4,42.358-4.408,9.918-2.158-2.963-6.8-9.417c-.052-.052-.11-.1-.169-.154L31.23,68.981l.654-2.943c.221.238.446.471.672.7A23.729,23.729,0,0,0,46.559,74.06ZM3.27,88.439A5.613,5.613,0,0,1,6.377,83.37C16.8,77.833,24.3,75.054,30.985,74.224L40.742,87.64,39.5,93.834H3.27Zm91.564,5.4H58.6L57.362,87.64l9.863-13.562c6.66,1,14.3,3.782,24.5,9.128a6.049,6.049,0,0,1,3.107,5.232v5.4Z"
                        transform="translate(-4 1)"
                      />
                    </g>
                  </g>
                </svg>
                <span className="title">Advisor</span>
                <span className="link-get-started">Get Started</span>
              </a>
            </li>
            <li>
              <a href="#">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="93.488"
                  height="93.465"
                  viewBox="0 0 93.488 93.465"
                >
                  <defs>
                    <style>
                      {`.a {
                                        fill: #00b9ff;
                                    }`}
                    </style>
                  </defs>
                  <g transform="translate(0 -0.062)">
                    <g transform="translate(0 0.062)">
                      <g transform="translate(0 0)">
                        <path
                          className="a"
                          d="M89.568,70.613A19.455,19.455,0,0,0,74.342,54.935L57.609,51.317h-.3v-9.5A18.14,18.14,0,0,0,64.845,27.2V18.152a18.09,18.09,0,1,0-36.18,0V27.2A17.93,17.93,0,0,0,36.2,41.82v9.5h-.3L19.168,54.784A19.455,19.455,0,0,0,3.942,70.462L.023,91.718a1.653,1.653,0,0,0,1.206,1.809H91.98a1.424,1.424,0,0,0,1.507-1.507v-.3ZM46.755,3.077a15.014,15.014,0,0,1,14.773,12.06H31.982A15.014,15.014,0,0,1,46.755,3.077ZM61.227,18.152,56.7,22.674h-19.9l-4.522-4.522ZM31.68,27.2V21.77l3.467,3.467a1.369,1.369,0,0,0,1.055.452h21.1a1.369,1.369,0,0,0,1.055-.452L61.83,21.77V27.2a15.075,15.075,0,0,1-30.15,0ZM54.293,43.629v10.1l-1.055,1.055A9.308,9.308,0,0,1,46.906,57.5h-.3a8.439,8.439,0,0,1-6.331-2.713l-1.055-1.055v-10.1a17.96,17.96,0,0,0,15.075,0Zm-21.1,11.457,2.563-.6,2.261,2.412A11.951,11.951,0,0,0,46.6,60.362h.3A12.208,12.208,0,0,0,55.5,56.895l2.412-2.412,2.563.6V59.91l-7.99,10.552a7.433,7.433,0,0,0-10.552-.754l-.754.754L33.188,59.91ZM46.755,79.959a4.522,4.522,0,1,1,4.522-4.522v9.045H48.263V81.467A1.424,1.424,0,0,0,46.755,79.959ZM22.635,90.512H3.339l.6-3.015H22.635Zm45.225.151H25.65V70.914H22.635V84.482H4.395L6.807,71.065A16.571,16.571,0,0,1,19.771,57.8l10.4-2.261v4.824a2.143,2.143,0,0,0,.3.9l9.045,12.06a8.9,8.9,0,0,0-.3,2.11,7.583,7.583,0,0,0,6.03,7.387v3.166A1.424,1.424,0,0,0,46.755,87.5h6.03a1.424,1.424,0,0,0,1.507-1.507V75.437a8.9,8.9,0,0,0-.3-2.11l9.045-12.06a2.143,2.143,0,0,0,.3-.9V55.689l10.4,2.261A16.571,16.571,0,0,1,86.7,71.216l2.412,13.417H70.875V71.065H67.86Zm3.015-.151V87.5H89.568l.6,3.015Z"
                          transform="translate(0 -0.062)"
                        />
                      </g>
                    </g>
                    <g transform="translate(45.248 73.929)">
                      <rect className="a" width="3.015" height="3.015" />
                    </g>
                  </g>
                </svg>
                <span className="title">Coaches</span>
                <span className="link-get-started">Get Started</span>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section className="common-padding college-plan-sec">
        <div className="container">
          <h3 className="sec-title">Your personalized college game plan</h3>
          <ul className="college-plan-listing">
            <li>
              <h4 className="title">01</h4>
              <h5 className="sub-title">Get evaluated</h5>
              <div className="short-content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry industry's
                </p>
              </div>
              <div className="link-box">
                <a href="#">
                  Learn more{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.025"
                    height="10.542"
                    viewBox="0 0 17.025 10.542"
                  >
                    <path
                      className="a"
                      d="M108.254,119.78l4.483,3.719-4.483,4m3.573-4H97.712"
                      transform="translate(-96.712 -118.372)"
                    />
                  </svg>{' '}
                </a>
              </div>
            </li>
            <li>
              <h4 className="title">02</h4>
              <h5 className="sub-title">Personal game plan</h5>
              <div className="short-content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry industry's
                </p>
              </div>
              <div className="link-box">
                <a href="#">
                  Learn more{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.025"
                    height="10.542"
                    viewBox="0 0 17.025 10.542"
                  >
                    <path
                      className="a"
                      d="M108.254,119.78l4.483,3.719-4.483,4m3.573-4H97.712"
                      transform="translate(-96.712 -118.372)"
                    />
                  </svg>{' '}
                </a>
              </div>
            </li>
            <li>
              <h4 className="title">03</h4>
              <h5 className="sub-title">Right college fit</h5>
              <div className="short-content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry industry's
                </p>
              </div>
              <div className="link-box">
                <a href="#">
                  Learn more{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.025"
                    height="10.542"
                    viewBox="0 0 17.025 10.542"
                  >
                    <path
                      className="a"
                      d="M108.254,119.78l4.483,3.719-4.483,4m3.573-4H97.712"
                      transform="translate(-96.712 -118.372)"
                    />
                  </svg>{' '}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <section className="common-padding success-stories-sec">
        <div className="container">
          <h3 className="sec-title">Success stories</h3>
          <ul className="success-stories-listing">
            <li>
              <div className="success-stories-box">
                <div className="img-box">
                  <img src={SuccessStory1} alt="" />
                </div>
                <div className="success-stories-content">
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy
                  </p>
                  <div className="title">Johan</div>
                </div>
              </div>
            </li>
            <li>
              <div className="success-stories-box">
                <div className="img-box">
                  <img src={SuccessStory2} alt="" />
                </div>
                <div className="success-stories-content">
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy dolor sit amet,
                  </p>
                  <div className="title">Dean</div>
                </div>
              </div>
            </li>
            <li>
              <div className="success-stories-box">
                <div className="img-box">
                  <img src={SuccessStory3} alt="" />
                </div>
                <div className="success-stories-content">
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy
                  </p>
                  <div className="title">David</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default ClaimProfile;
